import type { MapSettingsDataLayersResponse } from '~/map/map.repository';
import { getDefaultDataLayerSettings } from './mapSettingsDataLayers.factory';
import { mapSettingsDataLayersInitialState } from './mapSettingsDataLayers.reducer';
import type {
  DataLayer, MapSettingsDataLayersState,
} from './mapSettingsDataLayers.state';

export const mapSettingsDataLayersSerializer = {
  jsonToState: (json: MapSettingsDataLayersResponse): MapSettingsDataLayersState => {
    const { instances, ...jsonRest } = json;

    return {
      ...mapSettingsDataLayersInitialState,
      ...jsonRest,
      instances: instances ? instances.map(mapSettingsDataLayersResponseInstanceToState) : [],
    };
  },
  stateToJson: (state: MapSettingsDataLayersState): MapSettingsDataLayersResponse => {
    return state;
  },
};

export const mapSettingsDataLayersResponseInstanceToState = (
  instance: NonNullable<MapSettingsDataLayersResponse['instances']>[number],
): DataLayer => ({
  ...instance,
  data: {
    ...instance.data,
  },
  settings: {
    ...getDefaultDataLayerSettings(),
    ...(instance.settings ? instance.settings : {}),
  },
});
